import { closestCenter } from '@dnd-kit/core';

/**
 * Collision detection that prefers whole drop containers over the individual
 * cards inside them.
 *
 * Without it, dragging a card over a column full of cards resolves to whichever
 * *card* is nearest rather than to the column — so a drop into a dense column
 * lands somewhere the pointer wasn't. Checking the pointer against each
 * container's rect first makes "wherever the cursor is" the answer, and
 * closestCenter stays the fallback for the gaps between them.
 *
 * Was inlined in Tasks.js with a hardcoded list of board and matrix ids; taking
 * the ids as an argument is what lets the artifact shelf reuse it.
 */
export function createContainerCollisionDetection(containerIds) {
    const ids = new Set(containerIds);

    return function containerCollisionDetection(args) {
        const { droppableContainers, active, pointerCoordinates } = args;
        if (!pointerCoordinates || !active) return closestCenter(args);

        for (const container of droppableContainers) {
            if (!ids.has(container.id) || !container.rect.current) continue;
            const { left, right, top, bottom } = container.rect.current;
            const { x, y } = pointerCoordinates;
            if (x >= left && x <= right && y >= top && y <= bottom) {
                return [{ id: container.id }];
            }
        }

        return closestCenter(args);
    };
}

export default createContainerCollisionDetection;
